"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  placeholder: '搜索',
  cancelText: '取消'
};
exports.default = _default;